var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 17.3332C4.39685 17.3332 0.666016 13.6023 0.666016 8.99984C0.666016 4.39734 4.39685 0.666504 8.99935 0.666504C13.6018 0.666504 17.3327 4.39734 17.3327 8.99984C17.3327 13.6023 13.6018 17.3332 8.99935 17.3332ZM8.16852 12.3332L14.0602 6.44067L12.8819 5.26234L8.16852 9.9765L5.81102 7.619L4.63268 8.79734L8.16852 12.3332Z",
    fill: "#1F36C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBtn);
export default __webpack_public_path__ + "static/media/Save-btn.fdb6e1036a68c6898a0d9ff5ec5ab2d0.svg";
export { ForwardRef as ReactComponent };